import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { fieldsMatcher } from '../../../../../../../src/app/website/utils/form.validators';
import { TenantConfigService } from '../../../../../../../tenant-config/tenant-config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, UserInvitation } from '../../services/auth.service';
import { ToastService } from '../../../shared/services/toast.service';
import { NavigationService } from '../../services/navigation.service';
import { UserService } from '../../services/user.service';
import { PASSWORD_VALIDATORS } from '../../../shared/validators/password-policy';

@Component({
  selector: 'hfc-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent {
  public get token() {
    return this.route.snapshot.queryParamMap.get('token');
  }

  public get resetToken() {
    return this.route.snapshot.queryParamMap.get('reset-token');
  }

  public invitation: UserInvitation;
  public errorMessage: string;
  public isLoading = true;
  public isSubmitting = false;
  public isReset = false;
  public today = new Date();

  public form: UntypedFormGroup = new UntypedFormGroup(
    {
      password: new UntypedFormControl('', PASSWORD_VALIDATORS),
      confirmPassword: new UntypedFormControl('', Validators.required)
    },
    fieldsMatcher('password', 'confirmPassword')
  );

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private toastService: ToastService,
    private userService: UserService,
    public readonly tenantConfigService: TenantConfigService
  ) {
    this.isReset = !!this.resetToken;

    this.getInvitation();
  }

  public async onSubmit() {
    this.isSubmitting = true;

    try {
      const password = this.form.get('password').value;
      const session = this.isReset
        ? await this.authService.resetPassword(this.resetToken, password)
        : await this.authService.setPassword(this.token, password);

      this.userService.setUser(session);
      this.router.navigateByUrl('/login');
      this.toastService.add({ header: 'Password has been set.' });
    } catch (error) {
      this.toastService.add({ header: `Could not set password: ${error.error.error.message}` });
    } finally {
      this.isSubmitting = false;
    }
  }

  private async getInvitation() {
    try {
      this.invitation = this.isReset
        ? await this.authService.getResetPasswordInfo(this.resetToken)
        : await this.authService.getInvitationData(this.token);
    } catch (error) {
      this.errorMessage = error.error.error.message;
    }

    this.isLoading = false;
  }
}
